import { LocationStrategy } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UtilService {
  null?:any = null;

  constructor(
    private router: Router,
    private location: LocationStrategy
    ) { }

  error(message?: any, ...optionalParams: any[]) {
    if(environment.isDebug) {
      console.error(message, optionalParams);
    }
  }

  warn(message?: any, ...optionalParams: any[]) {
    if(environment.isDebug) {
      console.warn(message, optionalParams);
    }
  }

  devlog(message?: any, ...optionalParams: any[]) {
    if(environment.isDebug) {
      console.log(message, optionalParams);
    }
  }

  isNumeric(val: any): boolean {
    return !(val instanceof Array) && (val - parseFloat(val) + 1) >= 0;
  }

  preventBrowserBackButton(){
    // preventing back button in browser implemented by "Samba Siva"

    history.pushState(null, this.null, location.href);
    this.location.onPopState(() => {
      history.pushState(null, this.null, location.href);
    });
  }

  pageScroll() {
    //window.scrollBy(10,0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
}
